export default __webpack_public_path__ + "static/media/tu1.33ddcde6.png";